// extracted by mini-css-extract-plugin
export default {"text":"SlotDelete_text__dhV3E","error_text":"SlotDelete_error_text__aXmcP"};